import { IOrder } from "@/order/IOrder";

export interface ISortableOrder {
    // here all needed properties
    OrderStatus(): string;
    getDataWysyłki(): string;
    getExtraOrder():number;
    getDelayPenalty():number
    setDelayPenalty(penalty: number):void;
    getOdbiorcaGroup(): string;
    getDataWysyłkiOrig(): string;
    getPlanDataKoncaDruku():Date;
    getPlanDataKoncaPrzewijania():Date;
    getPlanPozNaDrukarce():number;
    getPlanPozNaPrzewijarce():number;
    getSortStringPrinter():string
    getSortIntegerRewinder():number;
    getSurowiec():string;
    getSortTechno1():string;
    getSortTechno2():string;
    getOdbiorca():string;
    getRewinderOrderGroup():string;
    getRewinderGroupDelayPenalty():number
    getDelayPenalty():number

    getPrinterOrderGroup():number


}



	

export class OrderSorter {

    static cmpNull(o1: any, o2: any): number {
        if (o1 === null && o2 === null) return 0;
        if (o1 === null && o2 !== null) return -1;
        if (o1 !== null && o2 === null) return 1;
        if (o1 !== null && o2 !== null) {
            if (o1==o2) return 0;
            if (o1<o2) return -1;
            if (o1>o2) return 1;
        }
        return 0;
    }

    static standardSorter(orders: ISortableOrder[], comparator: (a: ISortableOrder, b: ISortableOrder) => number) {
        orders.sort(comparator)
    }

    static compareByStatus(o1:ISortableOrder, o2:ISortableOrder): number {
        let ret = 0;
        
        ret = OrderSorter.cmpNull(o1.OrderStatus(), o2.OrderStatus());

        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getDataWysyłki(), o2.getDataWysyłki());
        }
        
        return ret;
    }

    static compareByPackaging(o1: ISortableOrder, o2: ISortableOrder): number {
        let ret = 0;

        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getDataWysyłki(), o2.getDataWysyłki());
        }

        if (ret === 0) {
            ret = OrderSorter.cmpNull(o2.getExtraOrder(), o1.getExtraOrder());
        }

        return ret;
    }

    static compareByDelayPenalty(o1: ISortableOrder, o2: ISortableOrder): number {
			const ret=OrderSorter.cmpNull(o1.getDelayPenalty(),o2.getDelayPenalty());
		return ret;			
    }
	

    static compareByOdbiorcaGroupDelayPenalty(o1: ISortableOrder, o2: ISortableOrder): number  {
        const ret=OrderSorter.cmpNull(o1.getOdbiorcaGroup(),o2.getOdbiorcaGroup());
        return ret;			
	}
	
    static compareByShippingDate(o1: ISortableOrder, o2: ISortableOrder) {
        let ret = 0;
        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getDataWysyłki(), o2.getDataWysyłki());
        }
        return ret;
	}

    static compareByShippingDateOrig(o1: ISortableOrder, o2: ISortableOrder) {
        let ret = 0;
        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getDataWysyłkiOrig(), o2.getDataWysyłkiOrig());
        }
        return ret;
	}

    static compareByPrintPlanDate(o1: ISortableOrder, o2: ISortableOrder) {
        let ret = 0;
        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getPlanDataKoncaDruku(), o2.getPlanDataKoncaDruku());
        }
        return ret;
    }


    static compareByRewindPlanDate(o1: ISortableOrder, o2: ISortableOrder) {
        let ret = 0;
        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getPlanDataKoncaPrzewijania(), o2.getPlanDataKoncaPrzewijania());
        }
        return ret;
    }

    static compareByPrinterPos(o1: ISortableOrder, o2: ISortableOrder) {
        let ret = 0;

        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.OrderStatus() == '340_W_DRUKU' ,o2.OrderStatus() == '340_W_DRUKU' );
        }
	
        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getPlanPozNaDrukarce(),o2.getPlanPozNaDrukarce());
        }
    return ret;
    }


    static compareByRewinderPos(o1: ISortableOrder, o2: ISortableOrder) {
        let ret = 0;

        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.OrderStatus() == '395_W_PRZEWIJANIU' ,o2.OrderStatus() == '395_W_PRZEWIJANIU' );
        }
	
        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getPlanPozNaPrzewijarce(),o2.getPlanPozNaPrzewijarce());
        }
    return ret;
	}

    static sortForPrinterBag(orders: ISortableOrder[], comparator:(a: ISortableOrder, b: ISortableOrder) => number): ISortableOrder[] {
        const groups: Record<string, ISortableOrder> = {};
        const v: ISortableOrder[] = [];
        const members: Record<string, ISortableOrder[]> = {};
        const vret: ISortableOrder[] = [];
        let added1 = 0;
        let added2 = 0;
    
        for (const o of orders) {
          const oo = groups[o.getPrinterOrderGroup()];
    
          if (!oo) {
            groups[o.getPrinterOrderGroup()] = o;
            v.push(o);
            const mv: ISortableOrder[] = [o];
            added1++;
            members[o.getPrinterOrderGroup()] = mv;
          } else {
            const mv = members[o.getPrinterOrderGroup()];
            mv.push(o);
            added1++;
          }
        }
    
        v.sort(OrderSorter.compareByPrinterTech2);
    
        for (const o of v) {
          const m = members[o.getPrinterOrderGroup()];
          m.sort(OrderSorter.compareByPrinterTech1);
    
          for (const oo of m) {
            vret.push(oo);
            added2++;
          }
        }
        return vret;
      }


    static compareByPrinterSortString(o1: ISortableOrder, o2: ISortableOrder) {
        let ret = 0;
        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getSortStringPrinter(), o2.getSortStringPrinter());
        }
    return ret;
	}

    static sortForRewinder(orders: ISortableOrder[], comparator:(a: ISortableOrder, b: ISortableOrder) => number): ISortableOrder[] {
        const groups = OrderSorter.createRewinderOrderGroups(orders);
    
        for (const order of orders) {
          const max = groups[order.getRewinderOrderGroup()];
          order.setDelayPenalty( max.getDelayPenalty() );
        }
    
        orders.sort(OrderSorter.compareByRewinderSortInt);
    
        return orders;
    }

    static createRewinderOrderGroups(orders: ISortableOrder[]): Record<string, ISortableOrder> {
        const groups: Record<string, ISortableOrder> = {};
    
        for (const order of orders) {
          const existingOrder = groups[order.getRewinderOrderGroup()];
    
          if (existingOrder) {
            if (order.getDelayPenalty() > existingOrder.getDelayPenalty()) {
              groups[order.getRewinderOrderGroup()] = order;
            }
          } else {
            groups[order.getRewinderOrderGroup()] = order;
          }
        }
    
        return groups;
      }

    static compareByRewinderSortInt(o1: ISortableOrder, o2: ISortableOrder) {
        let ret = 0;
        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getSortIntegerRewinder(), o2.getSortIntegerRewinder());
        }
    return ret;
	}


    static compareByPrinterTech1(o1: ISortableOrder, o2: ISortableOrder) {
        let ret = 0;
        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getSurowiec()+o1.getSortTechno1(), o2.getSurowiec()+o2.getSortTechno1());
        }
    return ret;
	}

    static compareByPrinterTech2(o1: ISortableOrder, o2: ISortableOrder) {
        let ret = 0;
        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getSurowiec().substring(0,4)+o1.getSortTechno2()+o1.getOdbiorca(), o2.getSurowiec().substring(0,4)+o2.getSortTechno2()+o2.getOdbiorca());
        }
    return ret;
	}

    static compareByCyfra(o1: ISortableOrder, o2: ISortableOrder) {
        let ret = 0;
        if (ret === 0) {
            ret = OrderSorter.cmpNull(o1.getSurowiec(), o2.getSurowiec());
        }
    return ret;
	}

    static compareByDelayPenaltyRewinder(o1: ISortableOrder, o2: ISortableOrder) {
			
            let ret = 0;
			
			if (o1.getRewinderOrderGroup()!=o2.getRewinderOrderGroup()) {
                ret = OrderSorter.cmpNull(o1.getExtraOrder(), o2.getExtraOrder());
                if (ret === 0) {
                    ret = OrderSorter.cmpNull(o1.OrderStatus() == '395_W_PRZEWIJANIU' ,o2.OrderStatus() == '395_W_PRZEWIJANIU' );
                }
                if (ret==0) {
                    ret = OrderSorter.cmpNull(o1.getRewinderGroupDelayPenalty(), o2.getRewinderGroupDelayPenalty());
                }
			} else {

                    ret = OrderSorter.cmpNull(o1.getExtraOrder(), o2.getExtraOrder());
                    if (ret === 0) {
                        ret = OrderSorter.cmpNull(o1.OrderStatus() == '395_W_PRZEWIJANIU' ,o2.OrderStatus() == '395_W_PRZEWIJANIU' );
                    }
                    if (ret==0) {
                        ret = OrderSorter.cmpNull(o1.getDelayPenalty(), o2.getDelayPenalty());
                    }
                    
            }
        return ret;
    }
	
}







